import React from "react";

import { cn } from "@/lib/utils";

type TradeLogSortableCellProps = React.HTMLAttributes<HTMLDivElement> & {
  /** Matches `DataTableColumnHeader` — only sortable columns use the padded header button. */
  align?: "left" | "right";
  className?: string;
  children: React.ReactNode;
};

/**
 * Wraps Trade Log body cells under sortable headers so values line up with
 * the header label (not the outer edge of the sort button).
 */
export function TradeLogSortableCell({
  align = "left",
  className,
  children,
  ...rest
}: TradeLogSortableCellProps): React.ReactElement {
  return (
    <div
      data-trade-log-sortable-cell={align}
      className={cn(className)}
      {...rest}
    >
      {children}
    </div>
  );
}
